import type { CommunityNote } from "../../api/community";
import { coverForNote } from "../community/community-data";

export type MaterialCharacterShape = "arch" | "circle" | "rect" | "pill";

export type MaterialCharacter = {
  id: string;
  english: string;
  name: string;
  description: string;
  /** 光泽与类别。 */
  tags: [string, string];
  shape: MaterialCharacterShape;
  /** 用于在社区作品里匹配真实应用场景的关键词。 */
  keywords: string[];
};

export const materialCharacters: MaterialCharacter[] = [
  { id: "travertine", english: "Travertine", name: "洞石", description: "多孔、温润，表面留着水流的痕迹。适合想让人安静下来的空间。", tags: ["哑光", "天然石材"], shape: "arch", keywords: ["洞石", "石材", "石头"] },
  { id: "marble", english: "Verde Marble", name: "绿大理石", description: "深绿底色上的白色脉络，冷静里带一点奢华。", tags: ["抛光", "天然石材"], shape: "circle", keywords: ["大理石", "岩板", "石材"] },
  { id: "steel", english: "Brushed Steel", name: "拉丝不锈钢", description: "细密的拉丝纹理，工业感与精准，科技品牌的常用语言。", tags: ["拉丝", "金属"], shape: "rect", keywords: ["不锈钢", "金属", "拉丝", "铝"] },
  { id: "velvet", english: "Velvet", name: "丝绒", description: "随光线流动的柔光，亲密、浪漫，适合美妆与时尚。", tags: ["柔光", "织物"], shape: "pill", keywords: ["丝绒", "绒面", "织物", "面料"] },
  { id: "walnut", english: "Walnut", name: "胡桃木", description: "深浅交错的木纹，保留手作的温度。", tags: ["油蜡", "木材"], shape: "arch", keywords: ["胡桃木", "木纹", "实木", "木材"] },
  { id: "terracotta", english: "Terracotta", name: "陶土", description: "粗粝的颗粒与大地色，原始而真诚。", tags: ["粗面", "陶土"], shape: "circle", keywords: ["陶土", "陶瓷", "陶", "瓷"] },
];

function noteText(note: CommunityNote) {
  return `${note.title} ${note.topic || ""} ${note.content || ""}`;
}

/**
 * 给每种材质配一件社区作品作为真实应用场景：先按关键词匹配，
 * 匹配不到时依次使用尚未分配的带封面作品，保证同一作品不重复出现。
 */
export function matchCharacterNotes(characters: MaterialCharacter[], notes: CommunityNote[]) {
  const pool = notes.filter((note) => Boolean(coverForNote(note)));
  const used = new Set<string>();
  const matched = new Map<string, CommunityNote>();
  characters.forEach((item) => {
    const hit = pool.find((note) => !used.has(note.id) && item.keywords.some((word) => noteText(note).includes(word)));
    if (hit) {
      used.add(hit.id);
      matched.set(item.id, hit);
    }
  });
  characters.forEach((item) => {
    if (matched.has(item.id)) return;
    const next = pool.find((note) => !used.has(note.id));
    if (!next) return;
    used.add(next.id);
    matched.set(item.id, next);
  });
  return matched;
}
